// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vm-modal[data-v-12563fcc]{display:flex;justify-content:center}.vm-modal iframe#iframeVisaMobileInfo[data-v-12563fcc]{width:320px;height:660px;border:none}", ""]);
// Exports
module.exports = exports;
